import { Partial } from '@40seas/entities/common';
import { CreditReview } from './credit-review.entity';

export class UpdateCreditReviewDto extends Partial(CreditReview) {}
